import type { AppProps } from '@client/ClientApp.types';
import { ContainerModule } from 'inversify';
import { container } from '@shared/common/dependency-injection/domain/container';
import { HelpCenterDependencyTypes } from '@client/feature/help-center/help-center.dependency-types';

let helpCenterContainerModule: ContainerModule | null = null;

export const loadHelpCenterContainerModule = (appProps: AppProps) => {
  if (helpCenterContainerModule !== null) {
    return;
  }

  helpCenterContainerModule = new ContainerModule((options) => {
    options.bind<string>(HelpCenterDependencyTypes.HelpUrl).toConstantValue(appProps.helpUrl ?? '');
  });

  container.load(helpCenterContainerModule);
};

export { helpCenterContainerModule };
